import React, { useEffect, useState } from 'react';
import { all_routes } from '../../../feature-module/router/all_routes';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { useAuth } from '../../auth/AuthProvider';
import {t} from "../../../lang/index"

interface Servico {
  id: number;
  nome: string;
  descricao?: string;
  icone?: string;
  comissao?: number;
}

const Sidebar: React.FC = () => {
  const routes = all_routes;
  const location = useLocation();
  const navigate = useNavigate();
  const [subdroptoggle, setsubdroptoggle] = useState(false);
  const [servicosFornecidos, setServicosFornecidos] = useState<Servico[]>([]);
  const { user, setUser, setIsLoggedIn, setIsAgent } = useAuth(); // ✅ usar useAuth direto
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    location.pathname.includes('booking')
      ? setsubdroptoggle(true)
      : setsubdroptoggle(false);
  }, [location.pathname]);

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch(`${BASE_URL}/empresas/minha`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Erro ao buscar empresa');

        const data = await response.json();
        setServicosFornecidos(data.servicos || []);
      } catch (error) {
        console.error('Erro ao buscar serviços fornecidos:', error);
      }
    };

    fetchEmpresa();
  }, [BASE_URL]);

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    localStorage.removeItem('token');
    setUser(null);
    setIsLoggedIn(false);
    setIsAgent(false);
    navigate(routes.home1);
  };

  const sidebarText = t("agentSidebar"); // pega o objeto agentSidebar do idioma atual

  return (
    <div
      className="card user-sidebar agent-sidebar theiaStickySidebar"
      style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      {/* Cabeçalho fixo */}
      <div className="card-header user-sidebar-header text-center bg-gray-transparent">
        <div className="agent-profile d-inline-flex align-items-center justify-content-center">
          {user?.foto?.id ? (
            <img
              src={`${BASE_URL}/uploads/${user.foto.id}`}
              alt={user?.nome || '--'}
              className="img-fluid rounded-circle"
              style={{ width: '60px', height: '60px', objectFit: 'cover' }}
            />
          ) : (
            <ImageWithBasePath
              src="assets/img/users/user-43.jpg"
              alt="image"
              className="img-fluid rounded-circle"
            />
          )}
          <Link
            to={routes.agentSettings}
            className="avatar avatar-sm rounded-circle btn btn-primary d-flex align-items-center justify-content-center p-0 ms-2"
          >
            <i className="isax isax-edit-2 fs-14" />
          </Link>
        </div>

        <h6 className="fs-16">{user?.nome || '--'}</h6>
        <p className="fs-14 mb-2">{user?.email || 'email@exemplo.com'}</p>

        <div className="d-flex align-items-center justify-content-center notify-item">
          <Link
            to={routes.agentNotification}
            className="rounded-circle btn btn-white d-flex align-items-center justify-content-center p-0 me-2 position-relative"
          >
            <i className="isax isax-notification-bing5 fs-20" />
            <span className="position-absolute p-1 bg-secondary rounded-circle" />
          </Link>
          <Link
            to={routes.agentChat}
            className="rounded-circle btn btn-white d-flex align-items-center justify-content-center p-0 position-relative"
          >
            <i className="isax isax-message-square5 fs-20" />
            <span className="position-absolute p-1 bg-danger rounded-circle" />
          </Link>
        </div>
      </div>

      {/* Corpo da sidebar com scroll */}
      <div
        className="card-body user-sidebar-body"
        style={{ flex: 1, overflowY: 'auto' }}
      >
        <ul>
          <li>
            <Link
              to={routes.agentDashboard}
              className={`d-flex align-items-center ${location.pathname === routes.agentDashboard ? 'active' : ''}`}
            >
              <i className="isax isax-grid-55 me-2" />
              {sidebarText.dashboard}
            </Link>
          </li>

          {servicosFornecidos.length > 0 && (
            <li className="submenu">
              <Link
                to="#"
                onClick={() => setsubdroptoggle(!subdroptoggle)}
                className={`d-block ${subdroptoggle ? 'subdrop' : ''} ${location.pathname.includes('booking') ? 'active' : ''}`}
              >
                <i className="isax isax-calendar-tick5 me-2" />
                <span>{sidebarText.bookings}</span>
                <span className="menu-arrow" />
              </Link>
              <ul className={`${subdroptoggle ? 'd-block' : ''}`}>
                {servicosFornecidos.some(s => s.nome === 'Tuk Tuk') && (
                  <li>
                    <Link
                      to={routes.agentTukTukBooking}
                      className={`d-flex align-items-center ${location.pathname === routes.agentTukTukBooking ? 'active' : ''}`}
                    >
                      <i className="isax isax-calendar-tick5 me-2" />
                      {sidebarText.tukTukBookings}
                    </Link>
                  </li>
                )}
                {servicosFornecidos.some(s => s.nome === 'Hotel') && (
                  <li>
                    <Link
                      to={routes.agentHotelBooking}
                      className={`fs-14 d-inline-flex align-items-center ${location.pathname.includes('agent-hotel-booking') ? 'active' : ''}`}
                    >
                      {sidebarText.hotelBookings}
                    </Link>
                  </li>
                )}
                {servicosFornecidos.some(s => s.nome === 'Car') && (
                  <li>
                    <Link
                      to={routes.agentCarBooking}
                      className={`fs-14 d-inline-flex align-items-center ${location.pathname.includes('agent-car-booking') ? 'active' : ''}`}
                    >
                      {sidebarText.carBookings}
                    </Link>
                  </li>
                )}
                {/* Continue para Cruise, Tour, Flight usando sidebarText.cruiseBookings etc */}
              </ul>
            </li>
          )}

          <li>
            <Link
              to={routes.agentEnquirers}
              className={`d-flex align-items-center ${location.pathname === routes.agentEnquirers ? 'active' : ''}`}
            >
              <i className="isax isax-magic-star5 me-2" />
              {sidebarText.enquiries}
            </Link>
          </li>

          <li>
            <Link
              to={routes.agentEarnings}
              className={`d-flex align-items-center ${location.pathname === routes.agentEarnings ? 'active' : ''}`}
            >
              <i className="isax isax-wallet-add-15 me-2" />
              {sidebarText.earnings}
            </Link>
          </li>

          <li>
            <Link
              to={routes.agentReview}
              className={`d-flex align-items-center ${location.pathname === routes.agentReview ? 'active' : ''}`}
            >
              <i className="isax isax-magic-star5 me-2" />
              {sidebarText.reviews}
            </Link>
          </li>

          <li>
            <Link
              to={routes.userSupport}
              className={`d-flex align-items-center ${location.pathname === routes.agentReview ? 'active' : ''}`}
            >
              <i className="isax isax-headphone me-2" />
              {sidebarText.support}
            </Link>
          </li>

          {servicosFornecidos.length > 0 && (
            <li>
              <Link
                to={routes.agentServiceEnrollment}
                className={`d-flex align-items-center ${location.pathname === routes.agentServiceEnrollment ? 'active' : ''}`}
              >
                <i className="isax isax-box me-2" /> {sidebarText.serviceEnrollment}
              </Link>
            </li>
          )}

          {(servicosFornecidos.some(s => s.nome === 'Tuk Tuk') || servicosFornecidos.some(s => s.nome === 'Car Rental')) && (
            <li>
              <Link
                to={routes.agentDrivers}
                className={`d-flex align-items-center ${location.pathname === routes.agentDrivers ? 'active' : ''}`}
              >
                <i className="isax isax-user me-2" />
                {sidebarText.drivers}
              </Link>
            </li>
          )}

          {servicosFornecidos.some(s => s.nome === 'Tuk Tuk') && (
            <li>
              <Link
                to={routes.agentVehicles}
                className={`d-flex align-items-center ${location.pathname === routes.agentVehicles ? 'active' : ''}`}
              >
                <i className="isax isax-truck me-2" />
                {sidebarText.tukTukVehicles}
              </Link>
            </li>
          )}

          <li>
            <Link
              to={routes.agentSettings}
              className={`d-flex align-items-center ${location.pathname.includes('settings') ? 'active' : ''}`}
            >
              <i className="isax isax-setting-25" /> {sidebarText.settings}
            </Link>
          </li>

          <li>
            <Link
              to={routes.home1}
              onClick={handleLogout}
              className="d-flex align-items-center pb-0"
            >
              <i className="isax isax-logout-15" /> {sidebarText.logout}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
